import Rule from '../configuration/rule/Rule'
import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import Formula from '../configuration/formula/Formula'

export default function MainRule (props) {
  const activePath = props.activePath
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Rules'),
      component: <Rule />,
      to: '/process/rules',
      permissionCode: 'RULES_TAB'
    },
    {
      title: t_('Formulas'),
      component: <Formula />,
      to: '/process/formulas',
      permissionCode: 'FORMULAS_TAB'
    }
  ]
  return <SmartNavigator componentsInfo={componentsInfo} selected={activePath} sticky={false} />
}
